<div class="error-box" style="max-height: 300px; overflow-y: auto">
    <p *ngFor="let error of errors">{{ error }}</p>
</div>
